import { LenderYieldComplete } from './types'

/**
 * Extract the effective oracle price for risk calculations.
 * Falls back to general price if oracle price is not available.
 */
export function getOraclePrice(meta: LenderYieldComplete): number {
  const oracleUSD = meta?.oraclePrice?.oraclePriceUsd
  if (oracleUSD != null && oracleUSD > 0) return oracleUSD
  return meta?.price?.priceUsd ?? 1
}

/**
 * Extract general display price.
 */
export function getDisplayPrice(meta: LenderYieldComplete): number {
  return meta?.price?.priceUsd ?? 1
}
